/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  CurveLPTokensMagician,
  CurveLPTokensMagicianInterface,
} from "../CurveLPTokensMagician";

const _abi = [
  {
    inputs: [],
    name: "InvalidCurvePriceProviderLPTokenPair",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrNotSupportedLPToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "coin",
        type: "address",
      },
    ],
    name: "Cached",
    type: "event",
  },
  {
    inputs: [],
    name: "FETCHERS_REPO",
    outputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_COINS",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolCoins",
    outputs: [
      {
        internalType: "address",
        name: "coin",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class CurveLPTokensMagician__factory {
  static readonly abi = _abi;
  static createInterface(): CurveLPTokensMagicianInterface {
    return new utils.Interface(_abi) as CurveLPTokensMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveLPTokensMagician {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveLPTokensMagician;
  }
}
